import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './WishlistButton.css';

function WishlistButton({ productId, size = 'medium' }) {
	const [isWishlisted, setIsWishlisted] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const getToken = () => {
		return localStorage.getItem('access_token');
	};

	const isLoggedIn = () => {
		return !!getToken();
	};

	useEffect(() => {
		// 로그인 상태일 때만 찜 상태 확인
		if (isLoggedIn() && productId) {
			checkWishlistStatus();
		}
	}, [productId]);

	const checkWishlistStatus = async () => {
		try {
			const token = getToken();
			const response = await axios.get(
				`https://api.weartoday.kr/api/products/wishlist/check/?product=${productId}`,
				{
					headers: {
						'Authorization': `Bearer ${token}`
					}
				}
			);
			setIsWishlisted(response.data.is_wished);
		} catch (error) {
			// 401 에러 시 조용히 false 처리
			if (error.response?.status === 401) {
				setIsWishlisted(false);
				// 토큰 만료 시 자동 제거
				localStorage.removeItem('access_token');
				localStorage.removeItem('refresh_token');
				localStorage.removeItem('user');
			} else {
				console.error('찜 상태 확인 실패:', error);
				setIsWishlisted(false);
			}
		}
	};

	const handleClick = async (e) => {
		e.preventDefault();
		e.stopPropagation();
		
		if (!isLoggedIn()) {
			// 현재 URL을 저장하고 로그인 페이지로 이동
			const currentPath = location.pathname + location.search;
			localStorage.setItem('redirectPath', currentPath);
			alert('로그인이 필요한 서비스입니다.');
			navigate('/login');
			return;
		}

		setLoading(true);

		try {
			const token = getToken();
			
			const response = await axios.post(
				'https://api.weartoday.kr/api/products/wishlist/toggle/',
				{ product: productId },
				{
					headers: {
						'Authorization': `Bearer ${token}`,
						'Content-Type': 'application/json'
					}
				}
			);
			
			setIsWishlisted(response.data.is_wished);
			// 성공 메시지 제거 (조용히 처리)
			window.dispatchEvent(new Event('wishlistUpdated'));
			
		} catch (error) {
			console.error('찜하기 오류:', error);
			
			if (error.response) {
				if (error.response.status === 401) {
					// 토큰 만료 시에도 현재 URL 저장
					const currentPath = location.pathname + location.search;
					localStorage.setItem('redirectPath', currentPath);
					alert('로그인이 만료되었습니다. 다시 로그인해주세요.');
					localStorage.removeItem('access_token');
					localStorage.removeItem('refresh_token');
					localStorage.removeItem('user');
					navigate('/login');
				} else {
					alert(error.response.data.message || '오류가 발생했습니다.');
				}
			} else {
				alert('서버와 연결할 수 없습니다.');
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<button
			className={`wishlist-button ${size} ${isWishlisted ? 'active' : ''}`}
			onClick={handleClick}
			disabled={loading}
			title={isWishlisted ? '찜 해제' : '찜하기'}
		>
			{loading ? '⏳' : isWishlisted ? '💖' : '🤍'}
		</button>
	);
}

export default WishlistButton;